import { Tag, Typography } from "antd";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const StyledLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  width: 30%;
  height: 92px;
  justify-content: space-between;
  background: #ffffff;
  box-shadow: 0px 8px 22px -6px rgba(24, 39, 75, 0.04),
    0px 14px 64px -4px rgba(24, 39, 75, 0.04);
  border-radius: 16px;
`;

export const StyledTytleWrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  border-bottom: #d7dce9 dashed 1px;
  padding-bottom: 8px;
`;

export const StyledDateWrapper = styled.div`
  display: flex;
  margin: 0;
  align-items: center;
`;

export const StyledTitle = styled(Typography.Title)`
  color: #2b303b;

  &.ant-typography {
    margin: 0;
  }
`;

export const StyledText = styled(Typography.Text)`
  margin-right: 12px;
  margin-left: 10px;
  color: ${"#8c8c8c"};
  font-size: 12px;
`;

export const StyledTag = styled(Tag)`
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 76px;
  height: 16px;

  &.actual {
    background: #e0f7ea;
    color: #51ad77;
  }

  &.updated {
    background: #fffbe6;
    color: #faad14;
  }
`;
